import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import classNames from 'clsx';
import { useLocation } from 'react-router-dom';

import { LabelEnum, RouteEnum } from 'app/shared/enums';
import { isCalculationForm } from 'app/shared/helpers/isCalculationForm';
import { useUser } from 'app/shared/hooks/useUser';
import { agencyMode } from 'app/services/env.service';
import { AppLogo } from 'app/components/AppLogo';
import { TopBarProps } from './TopBar.interfaces';
import { useStyles } from './TopBar.styles';

const TopBar: React.FunctionComponent<TopBarProps> = (props) => {
  const { children, className } = props;
  const classes = useStyles();
  const location = useLocation();
  const { isSkpUser } = useUser();

  const stickyDisabled =
    location.pathname === RouteEnum.TRAVEL_CALCULATION_RESULTS ||
    location.pathname === RouteEnum.CALCULATION_RESULTS;

  const calculateProgressIndicatorThreshold = () => {
    const indicator = document.querySelector(
      '#progress-indicator'
    ) as HTMLElement;

    if (!indicator) return 0;

    const offsetTop = indicator.offsetTop;
    const headerHeight = 80;

    return offsetTop - headerHeight;
  };

  const stickyProgressIndicatorTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: calculateProgressIndicatorThreshold(),
  });

  const scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return (
    <div data-inert-if-modal className={classes.rootFixedWrapper}>
      <AppBar
        position={stickyDisabled ? 'static' : 'fixed'}
        color="inherit"
        className={classNames(className, classes.root, {
          [classes.sticky]: !stickyDisabled && scrollTrigger,
          [classes.noBoxShadow]:
            isCalculationForm() && stickyProgressIndicatorTrigger,
        })}
      >
        <div className={classNames(classes.toolbarContainer)}>
          <Toolbar className={classes.toolbar} disableGutters>
            <div className={classes.toolbarColumn}>
              {isSkpUser ? (
                <AppLogo />
              ) : (
                <a href={'/'} target="_blank" rel="noopener noreferrer">
                  <AppLogo />
                </a>
              )}
              {!agencyMode && (
                <div className={classes.subheader}>
                  {LabelEnum.InsuranceComparison}
                </div>
              )}
            </div>
            <div className={classes.toolbarColumn}>{children}</div>
          </Toolbar>
        </div>
      </AppBar>
    </div>
  );
};

export default TopBar;
